module.exports = {
      id: "636c02ca7c2e8902dbbd1cc6aa943b24ownership-personal.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#636c02ca7c2e8902dbbd1cc6aa943b24ownership-personal.svg",
      toString: function () {
        return this.url;
      }
    }